// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__xFImZ","Content":"Layout_Content__E5KWw","Footer":"Layout_Footer__dqRPi"};